import React from "react";
import "./objectives.css";

function Objectives() {
  return (
    <div id="About" className="objectives-container">
      <h2>Objectives</h2>
      <p>
        At our core, we are dedicated to achieving key objectives that define
        our commitment to excellence. Explore how our services align with these
        fundamental goals to bring you innovative, cost-effective, and compliant
        solutions.
      </p>
      <div className="objectives-wrapper">
        <div className="objective">
          <h3 style={{ color: "blue" }}>Reducing costs</h3>
          Our commitment to cost efficiency drives our end-to-end software
          development process. By meticulously planning and optimizing every
          phase, we aim to deliver high-quality solutions while minimizing
          expenses. This ensures that our clients receive exceptional value
          without compromising on excellence.
        </div>
        <div className="objective objective-center">
          <h3>Improving productivity</h3>
          Through our cloud-based solutions, we focus on improving business
          productivity. By leveraging cutting-edge technologies and scalable
          cloud infrastructure, we empower organizations to achieve higher
          levels of efficiency, collaboration, and overall productivity in their
          day-to-day operations.
        </div>
        <div className="objective">
          <h3 style={{ color: "blue" }}>Ensuring governance and compliance</h3>
          Upholding governance and compliance standards is integral to our
          service offering. We navigate the complex landscape of regulations and
          ethical considerations, ensuring that our clients' software solutions
          adhere to industry standards. This commitment builds trust and
          transparency in every aspect of our development process.
        </div>
      </div>
    </div>
  );
}

export default Objectives;
